<template>
  <v-dialog v-model="value" max-width="290">
    <v-card>
      <v-card-title class="headline">ログアウト</v-card-title>
      <v-card-text>ログアウトしてもよろしいですか? </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="gray darken-1" text @click="closeLogoutDialog">
          キャンセル
        </v-btn>

        <v-btn color="primary darken-1" text @click="logout">はい</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
  },
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    closeLogoutDialog() {
      this.$emit("close");
    },
    logout() {
      this.closeLogoutDialog();
      this.$store.commit("setUid", null);
      this.$store.commit("setCurrentNoteId", null);
      this.$router.push("/");
    },
  },
};
</script>
